import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../components/MainCard/MainCard';
import ContainerFichaFormularioDeFiscalizacao from './components/ContainerFichaFormularioDeFiscalizacao';
import NovoFormularioDeFiscalizacao from './NovoFormularioDeFiscalizacao';
import Loading from '../../components/Loading/Loading';

//Api
import formularioVistoria_api from '../../api/formularioVistoria_api';
import { showMessage } from 'helpers/message';

export default function FichaFormularioDeFiscalizacao({ btnVoltar, id }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Controle do botão de edição
    const [editar, setEditar] = useState(false);
    const [formulario, setFormulario] = useState(null);
    useEffect(() => {
        setLoading(true);
        formularioVistoria_api.GetItem(id).then(response => {
            response.data.questoes.map(value => {
                value.sequencia = value.sequencia.toString();
                
                if (value.tipoValor == "Lista") {
                    const _opcoesQueGeramInconformidade = [];
                    value.opcoes = value.opcoes.map(value => {

                        const _option = { label: value.valor, value: value.valor };
                        if (value.id) {
                            _option.id = value.id
                        }
                        if (value.geraInconformidade) {
                            _opcoesQueGeramInconformidade.push(_option);
                        }
                        return _option;
                    });
                    value.opcoesQueGeramInconformidade = _opcoesQueGeramInconformidade;
                }
                return value;
            })

            response.data.cabecalhos.map(value => {
                value.sequencia = value.sequencia.toString();
                if (value.tipoValor == "Lista") {
                    value.opcoes = value.opcoes.map(value => {
                        const _option = { label: value.valor, value: value.valor }
                        if (value.id) {
                            _option.id = value.id;
                        }
                        return _option;
                    })
                }
                return value;
            })
            
            response.data.modalidades.map(value => {
                value.label = value.descricao;
                value.value = value.id;
            })
            setFormulario(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, []);
    if (editar) {
        return <NovoFormularioDeFiscalizacao formularioEdit={formulario} btnVoltar={btnVoltar} />
    }
    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={() => setEditar(true)}>
            {loading && <Loading />}
            {!!formulario &&
                <ContainerFichaFormularioDeFiscalizacao formulario={formulario} />
            }
        </MainCard>
    )
}